module.exports = __webpack_public_path__ + "media/images/img_rounge_5-febc1312fb0f4d7e7e88fc2f8c57dc66.jpg";